import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import HeroContent from './hero/HeroContent';
import HeroRocket from './hero/HeroRocket';

// Extracted motion configs to avoid re-creating objects on every render
const SPARKLE_ANIMATE = { y: [0, -20, 0], rotate: [0, 5, 0] };
const SPARKLE_TRANSITION = { duration: 6, repeat: Infinity, ease: 'easeInOut' };

const SCROLL_INDICATOR_ANIMATE = { y: [0, 10, 0] };
const SCROLL_INDICATOR_TRANSITION = { duration: 1.5, repeat: Infinity };

const SCROLL_DOT_ANIMATE = { y: [0, 12, 0] };
const SCROLL_DOT_TRANSITION = { duration: 1.5, repeat: Infinity };

const PULSE_DELAY_1S = { animationDelay: '1s' };
const PULSE_DELAY_2S = { animationDelay: '2s' };

const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      {/* Smooth Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.08),transparent_60%)]" />
        <div className="absolute top-20 left-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-[500px] h-[500px] bg-purple-500/10 rounded-full blur-3xl animate-pulse" style={PULSE_DELAY_1S} />
        <div className="absolute top-1/2 left-1/2 w-80 h-80 bg-orange-500/5 rounded-full blur-3xl animate-pulse" style={PULSE_DELAY_2S} />
      </div>

      {/* Floating Sparkle */}
      <motion.div
        animate={SPARKLE_ANIMATE}
        transition={SPARKLE_TRANSITION}
        className="absolute top-20 right-20 hidden lg:block"
      >
        <Sparkles className="w-8 h-8 text-orange-400" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <HeroContent onScrollTo={scrollToSection} />
          <HeroRocket />
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        animate={SCROLL_INDICATOR_ANIMATE}
        transition={SCROLL_INDICATOR_TRANSITION}
        className="absolute bottom-10 left-1/2 -translate-x-1/2"
      >
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <motion.div
            animate={SCROLL_DOT_ANIMATE}
            transition={SCROLL_DOT_TRANSITION}
            className="w-1.5 h-1.5 bg-white rounded-full"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
